import component from './family-plan-info.component';
import routes from './family-plan-info.routes';
import familyPlanUserInfoComponent from './../family-plan-info/family-plan-info.component';
import manageContactsDeleteDialogComponent from '../manage-contacts-delete-dialog/manage-contacts-delete-dialog.component';

export default angular
  .module('fizyweb.paycell.familyPlanInfo', [])
  .component('fizyPaycellFamilyPlanInfo', component)
  .component('manageContactsDeleteDialog', manageContactsDeleteDialogComponent)
  .component('familyPlanUserInfo', familyPlanUserInfoComponent)
  .config(routes).name;


  



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-info/family-plan-info.module.ts